<template>
    <div class="inner-addon left-addon">
        <input id="verdict-search" placeholder="Enter SHA1, URL, IP or Domain to Search" name="verdictSearchValue"
               ref="verdictSearchValue" @keyup.enter="verdictSearchHandler"/>
        <img src="../../assets/search_icon.png" id="verdict-search-icon"
             @click="verdictSearchHandler">
    </div>
</template>

<script>
    import Constants from '@/utils/constants'
    import Common from '@/utils/Common.vue'

    export default {
        name: "VerdictSearch",
        props: {
            onVerdictSearchHandler: {
                type: Function,
                required: false
            }
        },
        data() {
            return {
                pageName: "Verdict Search Bar"
            }
        },
        mixins: [Common],
        methods: {
            verdictSearchHandler() {
                let searchString = this.$refs.verdictSearchValue.value;
                this.$emit("onVerdictSearchHandler", searchString, this, this.pageName, true);
                // this.verdictSearchHandlerCommon(searchString, this, this.pageName);
            }
        }
    }
</script>

<style scoped>
    #verdict-search {
        margin-left: 3.5%;
        width: 23.5%;
        margin-bottom: 16px;
        background-color: rgb(27, 33, 41);
        font-size: 20px;
        border: 0;
        color: #475A67;
        font-family: Digital-Serial-Bold;
    }

    #verdict-search-icon {
        height: 32px;
        width: 32px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/verdict-search/VerdictSearch.vue